import type { TourStep } from './tourTypes.js'
import { uiTour } from './tours/uiTour.js'
import type React from 'react'
import type { TourCategories } from './tourCategoryMeta.js'

export type TourId =
  | 'BasicUI'
  | 'Organizations'
  | 'Lab Orders'
  | 'Customer Orders'
  | 'Finding Orders'
  | 'Projects'
  | 'LabCustomerOrders'
  | 'OrderProcessing'
  | 'Order Error Handling'

export interface TourMetaEntry {
  id: TourId
  label: string
  description: string
  icon?: React.ReactNode // Flexible: SVG, Lucide icon, even emoji
  category: TourCategories
}

export const tourMap: Record<TourId, TourStep[]> = {
  BasicUI: uiTour,
  Organizations: [],
  'Lab Orders': [],
  'Customer Orders': [],
  Projects: [],
  'Order Error Handling': [],
  'Finding Orders': [],
  LabCustomerOrders: [],
  OrderProcessing: []
}

export const tourMeta: Record<TourId, TourMetaEntry> = {
  'Finding Orders': {
    id: 'Finding Orders',
    label: 'Managing Orders',
    description: 'Covers managing your orders, order visibility and order sharing.',
    category: 'Orders'
  },
  BasicUI: {
    id: 'BasicUI',
    label: 'Basic UI Tour',
    description: 'Covers layout, navigation, and core UI patterns in Spcfy.',
    category: 'Basics',
  },
  Organizations: {
    id: 'Organizations',
    label: 'Organization Setup',
    description: 'Walkthrough for managing teams and permissions.',
    category: 'Admin',
  },
  LabCustomerOrders: {
    id: 'LabCustomerOrders',
    label: 'Handling customer orders for labs',
    description: 'Information for laboratories on how to proceed with customer initiated orders',
    category: 'Orders'
  },
  'Lab Orders': {
    id: 'Lab Orders',
    label: 'Lab Initiated Orders',
    description: 'Learn how laboratories can initiate order processing on spcfy',
    category: 'Orders',
  },
  'Customer Orders': {
    id: 'Customer Orders',
    label: 'Customer Initiated Orders',
    description: 'Learn how customers can initiate orders and find a laboratory to process their samples.',
    category: 'Orders',
  },
  Projects: {
    id: 'Projects',
    label: 'Projects Overview',
    description: 'Understand how to aggregate samples into spcfy Insight projects to analyze biodiversity data',
    category: 'Projects',
  },
  'Order Error Handling': {
    id: 'Order Error Handling',
    label: 'Handling Errors',
    description: 'Learn about errors occurring during spcfy processing and how you can resolve them.',
    category: 'Orders',
  },
  OrderProcessing: {
    id: 'OrderProcessing',
    label: 'Tracking Order Processing',
    description: 'Learn how you can get information about spcfy displays information during processing of your order',
    category: 'Orders'
  }
}
